<template>
    <div class="main-content-container container-fluid h-100" style="padding:0px !important">
          <div class="header-Panel btn-accent" style="padding:0px !important">
                <div class="s1 cursor-pointer" style="padding:25px" @click="about()">
                    <strong class="color-blue">About</strong>
                </div>

                <div class="s1 cursor-pointer" style="padding:25px" @click="ContactAs()">
                    <strong class="color-blue">Contact As</strong>
                </div>
                <div class="s1 cursor-pointer" style="padding:25px" @click="Register()">
                    <strong class="color-blue">Register</strong>
                </div>``
                <div class="s1 cursor-pointer" style="padding:25px" @click="Login()">
                    <strong class="color-blue">Login</strong>
                </div>

                <img id="main-logo" class="d-inline-block align-top mr-1" style="max-width: 80px;" src="@/assets/images/logo.png" alt="Dev Tool">
                <label style="padding:20px;padding-left:1px; font-weight:500; font-size:20px !important;"> Dev Tool </label>
            </div>
        <div class="row h-100 no-gutters">
            <div class="auth-form mx-auto my-auto col-md-10 col-lg-9">
                <div class="row">


                    <div class="card rbr col-md-12 col-lg-12" style="padding:0px !important">
                        <d-card-header class="border-bottom">
                            <strong class="s2 app_fontsize"> Contact As</strong>
                        </d-card-header>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label for="exampleInputEmail1">First Name</label>
                                        <input id="exampleInputEmail1" v-model="ContactAs.DataModel.Data.Registration.FirstName"  type="text" placeholder="First Name" class="form-control required-field" />
                                    </div>
                                    <div class="form-group">
                                        <label for="exampleInputEmail1">Last Name</label>
                                        <input id="exampleInputEmail1" v-model="ContactAs.DataModel.Data.Registration.LastName"  placeholder="Last Name" class="form-control required-field" />
                                    </div>
                                </div>

                                <div class="col-md-6 col-lg-6">
                                    <div class="form-group">
                                        <label for="exampleInputPassword1">EmailId</label>
                                        <input style="width:100% !important" id="exampleInputPassword1" v-model="ContactAs.DataModel.Data.Registration.EmailId"  type="text" placeholder="Email" class="form-control required-field" />
                                    </div>

                                    <div class="form-group">
                                        <label for="exampleInputPassword1">Contact Number</label>
                                        <input style="width:100% !important" id="exampleInputPassword1" v-model="ContactAs.DataModel.Data.Registration.ContactNumber"  type="text" placeholder="Contact Number" class="form-control required-field" />
                                    </div>

                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-12 col-lg-12">
                                    <div class="form-group">
                                      <label for="exampleInputPassword1">Message</label>
                                          <d-form-textarea  name="feDescription1" :rows="3" :max-rows="8"></d-form-textarea>
                                    </div>
                                </div>
                            </div>


                            <div class="row">
                                <button type="submit" class="btn btn-pill btn-accent d-table mx-auto" @click="CreateInvestor()" >Submit</button>
                            </div>
                        </div>
                        <div class="border-top card-footer">
                            <div class="auth-form__meta d-flex">
                                <a style="color: rgb(0, 123, 255); cursor:pointer;" @click="loginClick()" target="_self">Redirect to Login</a>
                            </div>
                        </div>
                    </div>
                    <div class="auth-form__meta d-flex mt-4">
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import Utilities from '@/Utilities/Utilities';
import axios from 'axios';
export default {
    name: 'ContactAs',
    data() {
        return {
            ContactAs: {
                PageType: 'Master', // Master, Transaction, Dashboard, Tabb edDashboard
                PageLoad: true, // block/none
                DataModel: {
                    Data: {
                      Registration:{
                        Id:0,
                        FirstName:null,
                        LastName:null,
                        EmailId:null,
                        ContactNumber:null,
                        City:null,
                        Country:null,
                        BankAccountNumber:null,
                        IFSC:null,
                        Status:"New",
                        BatchId:0,
                        CreatedBy:1,
                      },
                      User:{
                          Id:0,
                          InvestorId:0,
                          Username:null,
                          Password:null,
                          ConfirmPassword:null,
                      }
                    },
                    UIData: {},
                },
                PageState: 'Default', // Default, Changed/Dirty, Submitted, PageLoading Dirty means some values are changed in the page
                TabInfo: {
                    SelectedTabIndex: 0,
                    NumberOfTabs: 0,
                },
                SessionInfo: {
                    SessionTimeout: false,
                    AuthToken: '',
                    SessionID: '',
                    PageInfo: {
                        ClientId: 0,
                        userId: 0,
                        WareHouseId: 0,
                    },
                },
                GridInfo: {},
                Events: {
                    EventRaised: 'Submitted', // Saved, Submitted, Cancelled, AutoCompletionTextChanged,
                    PageToNavigateWhenSubmitted: '', // We can go back to dashboard or stay on the Same page or to a specific page
                },
                ValidationInfo: {},
                ErrorInfo: [{
                    ErrorID: 1,
                    ErrorName: '',
                    ErrorMessage: '',
                }],
                Masters: {},
                Modal: {},
                CharRestrict: {},
            },
        };
    },
    mounted() {},
    methods: {
        loginClick() {
            Utilities.gotoRoute(this, "/Login");
        },
        CreateInvestor(){
    this.ContactAs.DataModel.Data.CreatedBy = new Date()
          this.ContactAs.DataModel.Data.CRUD = "Create";
          this.ContactAs.DataModel.Data.Token = "New";
          let vm =this;
          this.ContactAs.DataModel.Data.User.Username = this.ContactAs.DataModel.Data.Registration.ContactNumber;
          var dataString = JSON.stringify(this.ContactAs.DataModel.Data);
          axios.post("APIScript/PHP/APIService/Registration/Registration.php", dataString)
            .then(function (response) {
                if(response.data.ErrorInfo==null)
                {
                    vm.$swal.fire('Welcome', 'Registration Successfully Completed', 'success')
                    Utilities.gotoRoute(vm, "/login");
                }
                else
                {
                  console.log(response.data.ErrorInfo);
                  vm.$swal.fire('Oops...', 'Incorrect User name or password !', 'error')
                }
            })
            .catch(function (response) {
                return response;

            });
        },
           about(){
        Utilities.gotoRoute(this, "/About");
      },
      ContactAs(){
        Utilities.gotoRoute(this, "/ContactAs");
      },
      Register(){
        Utilities.gotoRoute(this, "/Registration");
      },
      Login(){
        Utilities.gotoRoute(this, "/Login");
      }
    },
};
</script>

<style scoped>
.custom-control-input:checked~.custom-control-label::before {
    background-color: #007bff !important;
}
</style>

